var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128026(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-128-026-1{fill:#fff;}.cls-128-026-2,.cls-128-026-3{fill:none;stroke-linecap:round;stroke-width:1.25px;}.cls-128-026-2{stroke:#6e6e6e;stroke-linejoin:round;}.cls-128-026-3{stroke:#ff6a10;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-026-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-128-026-2",
    d: "M92.65,18.54H102A1.47,1.47,0,0,1,103.46,20V54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-026-2",
    d: "M103.46,86.68v33.48A1.47,1.47,0,0,1,102,121.6H20.19a1.47,1.47,0,0,1-1.5-1.44V20a1.47,1.47,0,0,1,1.5-1.44H31.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-026-2",
    points: "92.75 24.3 98.79 24.3 98.79 62.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-026-2",
    points: "98.79 90.78 98.79 114.72 23.85 114.72 23.85 24.3 31.35 24.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-026-2",
    points: "74.61 14.68 92.33 14.68 92.33 24.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-026-2",
    points: "92.33 24.71 92.33 27.89 31.8 27.89 31.8 14.68 47.39 14.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-026-2",
    d: "M33.23,38.84H91.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-026-2",
    d: "M33.23,50.72H90.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-026-2",
    d: "M33.23,75.69H90.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-026-2",
    d: "M30,92H87.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-026-2",
    d: "M33.23,63.2H90.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-026-2",
    d: "M34.17,100.65H72.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-026-3",
    d: "M76.45,97.06l6,9.18s5.61-7.54,9.65-13.65"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-026-2",
    cx: 52.66,
    cy: 10.57,
    r: 1.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-026-2",
    cx: 69.14,
    cy: 10.57,
    r: 1.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-026-2",
    d: "M101.64,84.46l.08-.15,16.64-32.46.41-.8,1.77-3.46c.72-1.4-.45-3.44-2.59-4.53s-5-1.13-5.72.27l-1.77,3.46-.41.8L93.41,80.05l-.07.15v.14l.42,9.9,7.75-5.71Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-026-2",
    x1: 109.32,
    y1: 49.01,
    x2: 117.63,
    y2: 53.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-026-2",
    x1: 110.57,
    y1: 46.57,
    x2: 118.88,
    y2: 50.83
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-026-2",
    points: "93.34 80.2 97.38 83.19 101.64 84.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-026-2",
    points: "93.52 84.79 95.63 86.61 98.08 87.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-026-2",
    x1: 36.93,
    y1: 14.78,
    x2: 34.96,
    y2: 17.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-026-2",
    x1: 41,
    y1: 14.78,
    x2: 39.03,
    y2: 17.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-026-2",
    x1: 45.06,
    y1: 14.78,
    x2: 43.09,
    y2: 17.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-026-2",
    x1: 80.39,
    y1: 14.78,
    x2: 78.42,
    y2: 17.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-026-2",
    x1: 84.45,
    y1: 14.78,
    x2: 82.48,
    y2: 17.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-026-2",
    x1: 88.52,
    y1: 14.78,
    x2: 86.55,
    y2: 17.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128-026-2",
    points: "74.08 6.4 47.92 6.4 47.92 15.29 53.69 15.29 53.69 18.93 68.31 18.93 68.31 15.29 74.08 15.29 74.08 6.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128026);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_026.670a3d44f34eadf775bf65fc22fc9cfe.svg";
export { ForwardRef as ReactComponent };